import { motion, useScroll } from "framer-motion";
import { useRef } from "react";
import Nav from "../components/Nav";
import SiteMap from "../components/SiteMap";

import reggie from "../assets/reggie.jpg";
import silas from "../assets/silas.jpg";

export default function OurTeam() {

    const scroll = useRef(null)
    const m = window.innerWidth < 961;

    const { scrollY } = useScroll({
        container: scroll
    })


    return (
        <div ref={scroll} id="team-wrapper">
            <Nav scrollY={scrollY} noInverse />
            <motion.div >
                <motion.h2 initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1}} className="title" style={{ textAlign: 'center', margin: '0 auto', marginTop: m ? '20px' : "10vh"}}>Our Team</motion.h2>
            </motion.div>
            <div id="teamView">
                <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="team-card">
                    <img src={reggie} alt="reggie" id="profile" />
                    <h2>Singaye PR</h2>
                    <h3>Co. Founder & Developer</h3>
                </motion.div>
                <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2 }} className="team-card">
                    <img src={silas} alt="silas" id="profile" />
                    <h2>Phosiwa S</h2>
                    <h3>Co. Founder & Marketing</h3>
                </motion.div>
            </div>
            <SiteMap scrollY={scrollY} />
        </div>
    )
}